import React from "react";
import { Button } from "../../common/Button/Button";
import Spinner from "../../common/Spinner/Spinner";
import { useEffect,useState } from "react";
import { toast } from "react-toastify";
import api from "../../utils/api";
import { getUser } from "../../utils/localStorage";
import ReactDatePicker from "react-datepicker";
import { useHistory } from "react-router-dom";
import moment from "moment";
import DNDExpirationUsersGrid from "../../components/ServiceRequests/Facilitator/DNDExpirationUsersGrid";

export default function ESPFollowUpsContainer(props)
{
    const [fromDate, setfromDate] = useState(new Date());
    const [toDate, settoDate] = useState(new Date());  
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(false);
    const [dndUsersData, setdndUsersData] = useState([]);

    useEffect(() => {
        if (!getUser()) 
        {
            history.push("/login");
        }
        else
        {
            getDNDUsersData();
        }
        
	},[]);

    const onSearchClick = async () => 
    {
        if(!fromDate)
        {
            toast(`Please select From date.`, {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            });
            return;
        }

        if(!toDate)
        {
            toast(`Please select To date.`, {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            });
            return;
        }
        getDNDUsersData();
    };

    const getDNDUsersData=()=>{
       
        let filterParameters={}
        if(fromDate)
        {
            filterParameters.fromDate=fromDate;//moment(fromDate).format('YYYY-MM-DD');
        }

        if(toDate)
        {
            filterParameters.toDate=toDate;//moment(toDate).format('YYYY-MM-DD');
        }

        setIsLoading(true);	
        const { tempServices } = api.getDNDUsersList(filterParameters).then(({ data }) => {
            setIsLoading(false);
			if(data)
            {
                if(data.data)
                {
                    setdndUsersData(data.data);
                }
                else
                {
                    if(data.message)
                    {
                        toast(String(data.message), {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        });
                    }
                    else
                    {
                        toast("Internal server error", {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        });
                    }
                }
                
            }
		}).catch((error) =>
        {
            setIsLoading(false);
            if(error.response.data.detail)
            {
                toast(String(error.response.data.detail), {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
            }
            else if(error.response.data.message)
            {
                toast(String(error.response.data.message), {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
            }
            else
            {
                toast("Internal server error", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
            }            
        });
    }

    const adjustedToDate = (date) => {
		let toDateAdjusted;
		if (date) {
			toDateAdjusted = new Date(date);

			toDateAdjusted = new Date(
				toDateAdjusted.setTime(
					toDateAdjusted.getTime() + 24 * 60 * 60 * 1000 - 1000
				)
			);
		}
		return toDateAdjusted;
	};

    return (
        <div className={`row row-container ${isLoading && "set-opacity"}`} >
			{isLoading && <Spinner className="center-screen" />}
            <div className="col-md-12 inline-margin-facilitatorview">
                <ReactDatePicker
                    dateFormat="dd/MM/yyyy"
                    selected={fromDate}
                    onChange={(date) =>setfromDate(date)}
                    placeholderText="From Date"
                />
                <ReactDatePicker
                    dateFormat="dd/MM/yyyy"
                    selected={toDate}
                    onChange={(date) =>settoDate(date)}
                    placeholderText="To Date"
                />
                <Button className="inline-button" onClick={onSearchClick}>Search</Button>
            </div>
            <div className="col-12 conv-mt10">
                <DNDExpirationUsersGrid
                    data={dndUsersData}
                />
            </div>            
       </div>
    )
}